import { readCookie } from "./helpers/read-cookie";
import { Api } from "./helpers/api";

export class FacebookConversions {
    static pushToGtm(eventName, additionalData) {
        if (typeof window.dataLayer !== 'undefined') {
            const customEventId = FacebookConversions.generateEventId();

            window.dataLayer.push({
                ...additionalData,
                event: eventName,
                customEventId: customEventId
            });

            return customEventId;
        }

        return null;
    }

    static convertGtmPixelEvent(type, eventId, data = {}) {
        const formData = new FormData();

        formData.set(window.csrfTokenName, window.csrfTokenValue);
        formData.set('eventId', eventId);
        formData.set('type', type);

        const fbp = readCookie('_fbp');
        if (fbp) {
            formData.set('fbp', fbp);
        }

        const urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.has('fbclid')) {
            formData.set('fbc', urlSearchParams.get('fbclid'));
        }

        if (urlSearchParams.has('fbTestCode')) {
            formData.set('fbTestCode', urlSearchParams.get('fbTestCode'));
        }

        for ( let key in data ) {
            formData.set(key, data[key]);
        }

        return Api.fbConvertPixelEvent(formData);
    }

    static generateEventId() {
        let randomness = 1000 + Math.round(Math.random() * 8999);

        let eventId = [
            (new Date()).getTime(),                     // timestamp, with millis
            btoa(navigator.userAgent).substring(0, 6),   // first 6 chars of base64 userAgent
            randomness                                  // 4 digits of pseudo-randomness
        ];

        return eventId.join('.');
    }
}

// Execute immediately, do not wait for the window load event as we wish to mutate the GTM container load event with an event Id
if (Array.isArray(window.dataLayer) && window.siteConfig.hasFacebookConversions) {
    const gtmLoadEvent = window.dataLayer.find((dataLayerEvent) => dataLayerEvent.hasOwnProperty('event') && dataLayerEvent.event === 'gtm.js');
    if (gtmLoadEvent) {
        gtmLoadEvent.customEventId = FacebookConversions.generateEventId();

        window.addEventListener('load', () => {
            FacebookConversions.convertGtmPixelEvent('PageView', gtmLoadEvent.customEventId);
        });
    }
}